export const FOOTER_LINK_WEBSITE_URL =
  'https://www.circulartree.com?utm_source=carbonblock&utm_medium=website&utm_campaign=backlink';
